<!--
 * @Description: 
 * @version: 
 * @Author: 小六
 * @Date: 2022-04-06 11:33:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-20 16:40:19
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  created() {
    if (
      localStorage.getItem("tokens") != "null" &&
      localStorage.getItem("tokens")
    ) {
      this.setToken(localStorage.getItem("tokens"));
      // console.log(localStorage.getItem("token"), "00000000000000000--appvue");
    } else {
      this.setToken("");
    }
  },
  methods: {
    ...mapActions({
      setToken: "setToken"
    })
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f1f5f8;

  /* text-align: center; */
  /* color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue